module.exports = __webpack_public_path__ + "img/제주렌트카.2fb3eb27.png";